import React, { useState, useEffect } from "react"
import NotificationList from "../components/Notifications/NotificationList"
import { IoSearchOutline } from "react-icons/io5"
import { useAuth0 } from "@auth0/auth0-react"
import useFetchNotifications from "../hooks/useFetchNotifications"
import useLogging from "../hooks/useLogging"

const Notifications = ({ sidebarOpen }) => {
	const { user, getAccessTokenSilently } = useAuth0()
	const [filter, setFilter] = useState("")
	const logging = useLogging()
	const { notificationsData } = useFetchNotifications(true)

	// Extract the user's unique identifier
	const userId = user?.sub

	// Filter notifications for the current user
	const userNotifications = notificationsData?.filter(
		n => n?.person_id?.toLowerCase() === userId?.toLowerCase()
	)

	const unreadCount = userNotifications ? userNotifications.filter(n => n.active).length : 0

	const handleFilterChange = e => {
		setFilter(e.target.value)
	}

	const dismissAllNotifications = async () => {
		try {
			const token = await getAccessTokenSilently({
				audience: process.env.REACT_APP_API_IDENTIFIER
			})
			const response = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/api/notifications/dismissAllForUser`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${token}`
					}
				}
			)
			if (!response.ok) {
				throw new Error("Failed to dismiss all notifications")
			}
		} catch (error) {
			logging.warn("Error dismissing all notifications:", error)
		}
	}

	useEffect(() => {
		if (userId) {
			dismissAllNotifications()
		}
		// `dismissAllNotifications` is stable within this component context.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userId])

	return (
		<div className={`${sidebarOpen ? "pl-64" : "pl-8"}`}>
			<div className="my-3 flex h-16 shrink-0 items-center justify-between bg-white px-4 sm:px-6 lg:px-8">
				<div className="flex items-center">
					<h1 className="font-bold text-4xl font-manrope text-custom-blue mr-4">
						Notifications
					</h1>
					<div className="flex items-center justify-center w-8 h-8 bg-customBlue text-white font-bold rounded-lg space-x-8">
						{unreadCount}
					</div>
				</div>
			</div>
			<div className="max-w-6xl mx-auto py-4 px-4 w-full">
				<div className="flex justify-between items-center py-2 bg-white mb-4">
					{" "}
					{/* Added mb-6 for extra space */}
					<div className="relative w-full max-w-md flex items-center">
						<IoSearchOutline className="absolute left-3 text-gray-400" />
						<input
							type="text"
							className="py-5 px-4 w-full border border-transparent rounded-md pl-8 text-sm h-8 bg-gray-100 text-gray-600 placeholder-gray-500 outline-none focus:outline-none focus:ring-0 focus:border-transparent"
							placeholder="Search notifications"
							value={filter}
							onChange={handleFilterChange}
						/>
					</div>
				</div>

				<div className="bg-white rounded-lg max-h-[82vh] overflow-y-auto w-full">
					<NotificationList notifications={userNotifications} filter={filter} />
				</div>
			</div>
		</div>
	)
}

export default Notifications
